import { Coins, Users, ShieldCheck, Sparkles } from "lucide-react";
import minifigSmartPlay from "@/assets/minifig-smart-play.jpg";

export const ValuePillarsDesktop = () => {
  const pillars = [
    {
      icon: Coins,
      title: "Revaloriza los sets que tienes y que no usas",
      desc: "Alquila los sets que ya conoces y genera unos ingresos con los que alquilar otros.",
      badge: "Ingresos pasivos",
    },
    {
      icon: Users,
      title: "Encuentra otros fans cerca de ti",
      desc: "Somos muchos y alguno es vecino tuyo, y si lo encuentras lejos nosotros gestionamos el transporte.",
      badge: "Comunidad local",
    },
    {
      icon: ShieldCheck,
      title: "Alquiler seguro con todas las garantías",
      desc: "La confianza es la base de una comunidad saludable. Verificación de usuarios, gestión de la reputación y fianzas: los mecanismos para dar tranquilidad.",
      badge: "Protección 100%",
    },
  ];

  return (
    <section
      data-section="value-pillars"
      className="py-16 lg:py-24 bg-white dark:bg-card border-b border-stone-200/60 dark:border-border"
    >
      <div className="container mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          {/* Columna Izquierda: Concepto "Juega de manera inteligente" + Ilustración Minifigura */}
          <div className="lg:col-span-5 flex flex-col justify-between">
            <div className="mb-6">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-50 dark:bg-amber-950/40 border border-amber-200/80 text-amber-900 dark:text-amber-300 text-xs font-semibold mb-3">
                <Sparkles className="h-3.5 w-3.5 text-amber-600" />
                Concepto Brickshare
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-[2.6rem] font-display font-bold text-stone-900 dark:text-foreground tracking-tight leading-[1.12]">
                Juega de manera inteligente
              </h2>
              <p className="mt-3 text-base text-stone-600 dark:text-muted-foreground leading-relaxed">
                Disfruta construyendo más. Acumula menos cajas. Pon tus sets a trabajar y accede a todo el universo LEGO® sin gastar una fortuna.
              </p>
            </div>

            <div className="relative rounded-3xl overflow-hidden bg-gradient-to-b from-[#FFFDF9] to-[#FAF5ED] dark:from-stone-900 dark:to-stone-950 border border-amber-100 dark:border-border shadow-md aspect-square max-w-[420px] mx-auto lg:mx-0 w-full group">
              <img
                src={minifigSmartPlay}
                alt="Minifigura LEGO con set y monedas de oro - Juega de manera inteligente"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
                width={800}
                height={800}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-950/40 via-transparent to-transparent pointer-events-none" />
              <div className="absolute bottom-4 left-4 right-4 bg-white/95 dark:bg-card/95 backdrop-blur-md rounded-2xl p-3 border border-stone-200/80 dark:border-border flex items-center justify-center text-xs font-semibold text-stone-800 dark:text-foreground shadow-sm">
                <span>Construye · Alquila · Ahorra</span>
              </div>
            </div>
          </div>

          {/* Columna Derecha: 3 Subsecciones en tarjetas alineadas */}
          <div className="lg:col-span-7 flex flex-col gap-5">
            {pillars.map((p, idx) => {
              const Icon = p.icon;
              return (
                <div
                  key={idx}
                  className="p-7 sm:p-8 rounded-3xl bg-[#FAF8F5] dark:bg-background border border-stone-200/80 dark:border-border hover:border-primary/40 hover:shadow-md transition-all duration-300 flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-6"
                >
                  <div className="h-14 w-14 shrink-0 rounded-2xl bg-white dark:bg-card border border-stone-200/90 dark:border-border flex items-center justify-center text-primary shadow-xs">
                    <Icon className="h-7 w-7" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1.5">
                      <span className="text-[11px] font-bold uppercase tracking-wider text-primary">
                        {p.badge}
                      </span>
                    </div>
                    <h3 className="text-lg sm:text-xl font-display font-bold text-stone-900 dark:text-foreground leading-snug mb-2">
                      {p.title}
                    </h3>
                    <p className="text-sm sm:text-base text-stone-600 dark:text-muted-foreground leading-relaxed">
                      {p.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuePillarsDesktop;
